var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _rect, _rect2, _rect3, _rect4, _ellipse4, _path4, _path5, _path6, _ellipse5, _path7, _path8, _path9, _path10, _rect5, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCivilStep2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 242,
    viewBox: "0 0 259 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252.88 148.688L229.992 93.375L208.065 148.688H252.88Z",
    stroke: "#DCDCDC",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.334 148.688L106.446 93.375L84.5184 148.688H129.334Z",
    stroke: "#DCDCDC",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M232.287 93.1707C227.644 92.8342 216.258 90.7886 207.86 85.2977C197.363 78.4341 189.692 70.9648 168.294 70.9648C146.895 70.9648 138.619 79.8472 128.727 85.2977C118.028 91.1931 109.886 92.4305 105.512 93.1707",
    stroke: "#DCDCDC",
    strokeWidth: 7
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.46923,
    cy: 7.46923,
    rx: 7.46923,
    ry: 7.46923,
    transform: "matrix(-1 0 0 1 175.765 44.9297)",
    fill: "#DCDCDC"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.45987,
    cy: 6.45987,
    rx: 6.45987,
    ry: 6.45987,
    transform: "matrix(-1 0 0 1 112.781 85.3008)",
    fill: "#DCDCDC"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.45987,
    cy: 6.45987,
    rx: 6.45987,
    ry: 6.45987,
    transform: "matrix(-1 0 0 1 236.73 85.3008)",
    fill: "#DCDCDC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14.9385,
    height: 31.8956,
    rx: 7.46923,
    transform: "matrix(-1 0 0 1 175.765 58.25)",
    fill: "#DCDCDC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14.9385,
    height: 31.8956,
    rx: 7.46923,
    transform: "matrix(-1 0 0 1 175.765 151.516)",
    fill: "#DCDCDC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8.47859,
    height: 100.128,
    rx: 4.2393,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 118.433 183.414)",
    fill: "#DCDCDC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 8.47859,
    height: 67.425,
    transform: "matrix(-1 0 0 1 172.535 87.3203)",
    fill: "#DCDCDC"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.46923,
    cy: 7.46923,
    rx: 7.46923,
    ry: 7.46923,
    transform: "matrix(-1 0 0 1 175.765 88.9414)",
    fill: "#DCDCDC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.518 189.867H211.9V183.609C186.061 183.609 174.352 167.593 171.728 159.586H165.268C157.678 178.32 136.939 183.407 127.518 183.609V189.867Z",
    fill: "#DCDCDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M258.129 144.646C258.129 149.893 255.088 154.925 249.674 158.635C244.26 162.345 236.918 164.43 229.262 164.43C221.605 164.43 214.263 162.345 208.849 158.635C203.435 154.925 200.394 149.893 200.394 144.646L229.262 144.646L258.129 144.646Z",
    fill: "#DCDCDC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.583 144.646C134.583 149.893 131.542 154.925 126.128 158.635C120.714 162.345 113.372 164.43 105.715 164.43C98.0593 164.43 90.7167 162.345 85.303 158.635C79.8893 154.925 76.8479 149.893 76.8479 144.646L105.715 144.646L134.583 144.646Z",
    fill: "#DCDCDC"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.9044,
    cy: 26.9044,
    rx: 26.9044,
    ry: 26.9044,
    transform: "matrix(-1 0 0 1 78.8096 95.5703)",
    fill: "#FFDCD5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0693 163.682L54.2969 143.952L78.2119 125.418L84.1907 163.682H62.0693Z",
    fill: "#FFDCD5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8761 115.321L27.395 111.734C32.178 96.7872 51.908 90.2105 67.4527 100.374C79.8886 108.506 79.8088 122.894 78.2145 129.072L60.8761 115.321Z",
    fill: "#212121"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.082 165.575C125.046 158.817 118.821 154.191 111.763 154.191H29.1965C18.4703 154.191 10.782 164.538 13.8771 174.808L30.5398 230.098C32.5764 236.856 38.8009 241.481 45.8592 241.481H128.426C139.152 241.481 146.84 231.134 143.745 220.864L127.082 165.575Z",
    fill: "#212121"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4286 185.234C50.7599 185.234 59.5606 193.281 62.6696 197.304L59.7998 207.954H46.8857C44.0159 207.954 39.7111 206.534 36.8413 204.404C34.5455 202.7 32.0583 197.541 31.1017 195.174C21.0574 195.174 12.448 194.464 12.448 190.914C12.448 187.364 27.5145 185.234 40.4286 185.234Z",
    fill: "#FFDCD5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 70,
    rx: 35,
    transform: "matrix(-1 0 0 1 101 0)",
    fill: "#212121"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0599 87.2812L67.5663 58.6914L34.5535 58.6914L51.0599 87.2812Z",
    fill: "#212121"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.056 19.016L48.632 42.824H54.68L55.256 19.016H48.056ZM55.544 49.448C55.64 47.336 53.816 45.56 51.608 45.608C49.544 45.56 47.72 47.336 47.672 49.448C47.72 51.656 49.544 53.432 51.608 53.384C53.816 53.432 55.64 51.656 55.544 49.448Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCivilStep2);
export default __webpack_public_path__ + "static/media/IcCivilStep2.b768b0c2be7d41602c5c1d6984f5d62d.svg";
export { ForwardRef as ReactComponent };